import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { withBreakPoints } from '../../hoc/withBreakPoints';
import { FOURTH_TEXT_COLOR, THIRD_TEXT_COLOR } from '../../theme/colors';

const RADIO_BUTTON_STYLE = {
  width: 16,
  height: 16,
  border: `2px solid ${FOURTH_TEXT_COLOR}`,
  boxSizing: 'border-box',
  borderRadius: '50%'
};

const ACTIVE_RADIO_BUTTON_STYLE = {
  width: '50%',
  height: '50%',
  background: THIRD_TEXT_COLOR,
  transform: 'translate(50%, 50%)',
  borderRadius: '50%'
};

function RadioBubble({ isActive, extraSmall, className = '' }) {
  const computedStyle = useMemo(() => ({
    ...RADIO_BUTTON_STYLE,
    borderColor: isActive ? THIRD_TEXT_COLOR : FOURTH_TEXT_COLOR,
    ...(extraSmall ? { width: 12, height: 12 } : {})
  }), [extraSmall, isActive]);
  return (
    <div style={computedStyle} className={className}>
      {isActive && <div style={ACTIVE_RADIO_BUTTON_STYLE} />}
    </div>
  );
}

export default withBreakPoints(RadioBubble);
